(()=>{
  'use strict';
  const root=document.getElementById('cg-library');
  if(!root)return;
  const storageKey='cg-books-einfuehrung-v2';
  try{if(localStorage.getItem(storageKey))return}catch(_error){}

  const search=root.querySelector('[data-filter="query"]');
  if(!search||search.value.trim()||new URLSearchParams(location.search).get('suche')?.trim()||document.activeElement===search)return;
  let step=0,target=null,finished=false;
  const tip=document.createElement('aside');
  tip.className='cg-books-welcome';
  tip.setAttribute('role','note');
  tip.setAttribute('aria-label','Tipps zur Bücherseite');
  tip.innerHTML='<button class="cg-books-welcome-close" type="button" aria-label="Hinweis schließen">×</button><span class="cg-books-welcome-step"></span><strong></strong><p></p><button class="cg-books-welcome-next" type="button"></button>';
  const steps=[
    {find:()=>search.closest('.library-search'),position:'after',title:'Hier Bücher suchen',text:'Titel, Autor, Thema oder Artikelnummer eingeben – zum Beispiel „Gebet bis 5 Euro“.',button:'Weitere Tipps'},
    {find:()=>root.querySelector('.library-filter-area'),position:'before',title:'Auswahl gezielt eingrenzen',text:'Kombiniere die Filter für Medienart, Sprache, Format oder Preis direkt unter diesem Hinweis.',button:'Weiter'},
    {find:()=>root.querySelector('[data-grid]'),position:'before',title:'Buch kurz ansehen',text:'Tippe auf ein Buch, um Inhalt, Preis und Bestellung zu öffnen.',button:'Verstanden'}
  ];
  function finish(){
    if(finished)return;
    finished=true;
    target?.classList.remove('cg-books-welcome-target');
    tip.remove();
    try{localStorage.setItem(storageKey,'1')}catch(_error){}
    root.removeEventListener('focusin',onInteraction);
    root.removeEventListener('click',onInteraction);
    document.removeEventListener('keydown',onKey);
  }
  function show(index){
    target?.classList.remove('cg-books-welcome-target');
    const item=steps[index];
    target=item?.find();
    if(!target||!target.getClientRects().length){finish();return}
    step=index;
    tip.dataset.step=String(step);
    tip.querySelector('.cg-books-welcome-step').textContent=(step+1)+' von '+steps.length;
    tip.querySelector('strong').textContent=item.title;
    tip.querySelector('p').textContent=item.text;
    tip.querySelector('.cg-books-welcome-next').textContent=item.button;
    target.insertAdjacentElement(item.position==='after'?'afterend':'beforebegin',tip);
    if(step===0)target.classList.add('cg-books-welcome-target');
    if(step>0){
      tip.querySelector('.cg-books-welcome-next').focus({preventScroll:true});
      const viewportTop=window.visualViewport?.offsetTop||0;
      const header=root.querySelector('.cg-header')?.getBoundingClientRect();
      const offset=Math.max(viewportTop,header?.bottom||0)+16;
      window.scrollBy({top:tip.getBoundingClientRect().top-offset,behavior:'instant'});
    }
  }
  function onInteraction(event){
    if(tip.contains(event.target))return;
    if(event.target===search||event.target.closest('[data-book],.library-filter-area,[data-category],[data-purpose],[data-toggle]'))finish();
  }
  function onKey(event){if(event.key==='Escape')finish()}
  tip.querySelector('.cg-books-welcome-close').addEventListener('click',finish);
  tip.querySelector('.cg-books-welcome-next').addEventListener('click',()=>step===steps.length-1?finish():show(step+1));
  root.addEventListener('focusin',onInteraction);
  root.addEventListener('click',onInteraction);
  document.addEventListener('keydown',onKey);
  show(0);
})();
